import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./index.scss";

import CustomActionMenu from "@components/CustomActionMenu/CustomActionMenu";
import Loader from "@components/Loader/Loader";
import CreditNotePreviewPDF from "@components/PreviewPdfModal/CreditNotePreviewPdf";
import PreviewPdfModal from "@components/PreviewPdfModal/PreviewPdfModal";
import { useSelector } from "react-redux";
import { useLazyGetOfferByIdQuery } from "store/offer/offerApi";

const AvoirsTable = ({ data, isAvoir }) => {
  const { t } = useTranslation();
  const user = useSelector((state) => state.auth.user);
  const companyId = user?.companyId?._id;

  const [openMenuId, setOpenMenuId] = useState(null);

  const [showPreview, setShowPreview] = useState(false);
  const [showPreviewFact, setShowPreviewFact] = useState(false);
  const [previewInvoiceData, setPreviewInvoiceData] = useState(null);
  const [creditNoteData, setCreditNoteData] = useState(null);
  const [offers, setOffers] = useState([]);
  console.log("🚀 ~ AvoirsTable ~ offers:", offers);
  const [getOfferById] = useLazyGetOfferByIdQuery();
  // 🧠 Charger toutes les offres pour les items de la facture sélectionnée
  useEffect(() => {
    if (!creditNoteData?.invoiceId?.offers || !companyId) return;

    const fetchOffers = async () => {
      try {
        const results = await Promise.all(
          creditNoteData.invoiceId.offers.map(async (item) => {
            const { data } = await getOfferById({
              id: item.idOffer,
              companyId,
            });
            return data;
          })
        );
        console.log("🚀 ~ fetchOffers ~ results:", results);
        setOffers(results);
      } catch (err) {
        console.error("❌ Erreur lors de la récupération des offres :", err);
      }
    };

    fetchOffers();
  }, [creditNoteData, companyId, getOfferById]);

  const actionMenu = (creditNote) => {
    const actions = [
      {
        label: t("quote.consult"),
        onClick: () => {
          setShowPreview(true);
          setOpenMenuId(null);
          setCreditNoteData(creditNote);
        },
      },
    ];

    return <CustomActionMenu data={creditNote} actions={actions} />;
  };

  return (
    <div style={{ overflowX: "auto" }}>
      <table className="invoice-table">
        <thead>
          <tr>
            <th>{t("avoir.ref")}</th>
            {isAvoir && <th>{t("avoir.ref_invoice")}</th>}
            <th>{t("avoir.client")}</th>
            <th>{t("avoir.total_ht")}</th>
            <th>{t("avoir.date")}</th>
            <th>{t("avoir.actions")}</th>
          </tr>
        </thead>
        <tbody>
          {data ? (
            data?.map((item) => (
              <tr key={item._id}>
                <td>{isAvoir ? item.numeroCreditNote : item.numeroInvoice}</td>

                {isAvoir && (
                  <td
                    style={{
                      color: "#2563eb",
                      fontWeight: "bold",
                      cursor: "pointer",
                      textDecoration: "underline",
                    }}
                    onClick={() => {
                      setPreviewInvoiceData(item?.invoiceId);
                      setShowPreviewFact(true);
                      setCreditNoteData(null);
                    }}>
                    {item?.invoiceId?.numeroInvoice}
                  </td>
                )}

                <td>
                  {isAvoir
                    ? item?.clientId?.name
                    : item?.clientName || item?.client?.name}
                </td>

                <td>{isAvoir ? item?.creditAmount : item?.totalHT}</td>
                <td>
                  {isAvoir
                    ? new Date(item?.date).toLocaleDateString("fr-FR")
                    : new Date(item?.dateDeFacturation).toLocaleDateString(
                        "fr-FR"
                      )}
                </td>

                <td>{actionMenu(item)}</td>
              </tr>
            ))
          ) : (
            <Loader />
          )}
        </tbody>
      </table>

      <PreviewPdfModal
        previewInvoiceData={previewInvoiceData}
        setShowPreview={setShowPreviewFact}
        showPreview={showPreviewFact}
        title={t("invoice.invoice")}
        isAvoir={false}
      />
      <PreviewPdfModal
        previewInvoiceData={previewInvoiceData}
        setShowPreview={setShowPreview}
        showPreview={showPreview}
        isAvoir={true}
        title={t("avoir.title_pdf_preview")}
        previewPdf={
          <CreditNotePreviewPDF
            creditNoteData={creditNoteData}
            companyId={companyId}
            offers={offers}
          />
        }
      />
    </div>
  );
};

export default AvoirsTable;
